import { render, staticRenderFns } from "./bonusLoader.vue?vue&type=template&id=03c7d5f9&scoped=true"
import script from "./bonusLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./bonusLoader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./bonusLoader.vue?vue&type=style&index=0&id=03c7d5f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c7d5f9",
  null
  
)

export default component.exports